<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <span style="color: red">Số EXP còn lại: {{ Number(dataExp.totalExp ?? 0) - Number(totalExp ?? 0) }}</span>
      <span>Tổng EXP: {{ dataExp.totalExp }}</span>
    </div>
    <div class="example-preview table-responsive overflow-auto mt-3">
      <table class="table text-left table-hover table-bordered table-vertical-center b-table">
        <thead>
        <tr style="background-color: #472F92; color: white">
          <th>Nhân sự</th>
          <th style="width: 130px">EXP</th>
          <th style="white-space: nowrap">Nhận xét</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in dataExpClone" :key="item.id">
          <td>
            <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
              <span class="line-clamp-1">{{ item.name }}</span>
            </el-tooltip>
          </td>
          <td>
            <el-input v-model="item.pivot.exp" placeholder="Nhập exp" @input="handleShareExp"/>
          </td>
          <td>
            <el-input v-model="item.pivot.feedback" placeholder="Nhập nhận xét"/>
          </td>
        </tr>
        </tbody>
      </table>
      <div style="display: flex;justify-content: end; margin-top: 20px">
        <button
            :disabled="disableSubmit"
            @click="handleSubmit"
            style="background: #472F92; border: none; color: white"
            class="btn btn-primary m-1"
        >
          <i class="el-icon-collection-tag"></i> Lưu thông tin
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import {SHARE_EXP_OKR} from "@/core/services/store/okrs/okr.module";

export default {
  name: 'TableShareExp',
  props: {
    dataExp: {
      type: Object,
      required: true,
      default: () => {}
    },
  },
  data() {
    return {
      dataExpClone: [],
    }
  },
  computed: {
    totalExp() {
      let total = 0
      this.dataExpClone.map(item => {
        total += Number(item.pivot.exp)
      })
      return total ?? 0
    },
    disableSubmit() {
      return this.totalExp > this.dataExp.totalExp || Number(this.dataExp.totalExp) - Number(this.totalExp) < 0
    },
  },
  mounted() {
    this.dataExpClone = [...this.dataExp.humans]
  },
  methods: {
    handleSubmit() {
      const payload = {
        id: this.dataExp.id,
        data: this.dataExpClone.map(item => {
          return  {
            user_id: item?.pivot?.user_id,
            exp: item?.pivot?.exp,
            feedback: item?.pivot?.feedback,
          }
        }),
      }
      this.$store.dispatch(SHARE_EXP_OKR, payload).then(res => {
        if (!res.error) {
          this.closeDialog()
          this.$emit('getListOkr');
          this.$message.success('Chia exp thành công')
        }
      })
    },
    handleShareExp() {
      if (this.totalExp > this.dataExp.totalExp) {
        this.$message.warning('Tổng điểm exp đã đạt giới hạn.Vui lòng chia lại exp !')
      }
    },
    closeDialog() {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped>

</style>
